'use client';

import Link from 'next/link';

interface NavigationButtonProps {
  href: string;
  children: React.ReactNode;
  // eslint-disable-next-line react/require-default-props
  className?: string;
}

export const NavigationButton = ({ href, children, className = '' }: NavigationButtonProps) => {
  return (
    <Link
      href={href}
      prefetch
      className={className}
    >
      {children}
    </Link>
  );
};
